import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth/auth.service';
import { LoginService } from '../../../services/login/login.service';

@Component({
  selector: 'app-close-session',
  templateUrl: './close-session.component.html',
  styleUrls: ['./close-session.component.css']
})
export class CloseSessionComponent implements OnInit {

  constructor(
    private _authService: AuthService,
    private router: Router,
    private _loginService: LoginService,
  ) { }

  ngOnInit() {
    this._loginService.cerrarSesion();
    this._authService.deleteToken();
    this.router.navigate(['/administrador']);
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/close-session/close-session.component.ts